import React, { Component } from 'react';
import config, { get } from 'react-global-configuration';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class CertificationGroupsCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      certification_ids_to_agroup: '',
      certification_group_name: '',
      type_group_edit: '',
      validate_month_time: '',
      type_applicability: '',
      certifications: [],
      certifications_list: [],
      types_applicability: [],
      id: this.props.certification_id,
    };

    //bind específico
    this.addCertificationsToGroup = this.addCertificationsToGroup.bind(this);
    this.deleteCertificationToGroup = this.deleteCertificationToGroup.bind(this);
    this.editGroup = this.editGroup.bind(this);

    //Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.certification_group_id !== 'undefined' && Array.isArray(newProps.certifications_list) && typeof newProps.certifications !== 'undefined') {
      this.setState({
        certification_group_id: newProps.certification_group_id,
        certification_group_name: newProps.certification_group_name,
        type_group_edit: newProps.group_type,
        validate_month_time: newProps.validate_month_time,
        type_applicability: newProps.applicability,
        certifications_list: newProps.certifications_list,
        types_applicability: newProps.types_applicability,
        certifications: newProps.certifications,
      });
    }
  }

  editGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.certification_group_name,
      validate_month_time: this.state.validate_month_time,
      type_applicability: this.state.type_applicability,
      type: this.state.type_group_edit,
      id: this.state.certification_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/grupo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  addCertificationsToGroup(event) {
    event.preventDefault();
    var datasave = {
      certification_ids_to_agroup: this.state.certification_ids_to_agroup,
      certification_group_id: this.state.certification_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/grupo/adicionar_certificados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteCertificationToGroup (event) {
    var certification_group_to_certification_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.deletarCertificadoDesseGrupo);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado/grupo/certificado/' + certification_group_to_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(certification_group_to_certification_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(certification_group_to_certification_id) {
    var certifications = this.state.certifications;
    certifications.map(function(dado, index){
      if (dado.certification_group_to_certification_id == certification_group_to_certification_id) {
        certifications.splice(index, 1);
      }
    });
    this.setState({certifications: certifications});
  }

  render() {
    var self = this;
    return (
<div>
  <hr/>
  <div>
    <h4 className="pull-left">{self.state.certification_group_name}</h4>
    <button className="btn btn-danger btn-sm pull-right" value={self.state.certification_group_id} onClick={this.props.deleteCertificationGroup}>
    <i className="fa fa-fw fa-trash"></i></button>
    <div className="clearfix"></div>
  </div>
  <hr/>
  <div className="row">
    <div className="col-md-6">
      <form onSubmit={self.editGroup}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.Nome}:</label>
              <input type="text" name='certification_group_name' className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.placeholder.NomeDoGrupo}value={self.state.certification_group_name} onChange={self.handleChange.bind(self, 'certification_group_name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type_group_edit"
                value={this.state.type_group_edit}
                searchable={true}
                placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.placeholder.SelecioneTipo}
                onChange={this.handleSelectChange.bind(this, 'type_group_edit')}
                options={[
                  {value: "E", label: this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.opcoesTipo.E},
                  {value: "OU", label: this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.opcoesTipo.OU},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.MesesAnteriores}:</label>
              <InputMask required value={this.state.validate_month_time}  maskChar={null} name="validate_month_time" mask="999" className="form-control" onChange={this.handleChange.bind(this, 'validate_month_time')} placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.placeholder.InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.Aplicabilidade}:</label>
              <Select
                className="form-field-name"
                name="type_applicability"
                value={this.state.type_applicability}
                searchable={true}
                placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.placeholder.SelecioneTipo}
                onChange={this.handleSelectChange.bind(this, 'type_applicability')}
                options={this.state.types_applicability}
              />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioGruposDeCertificado.botaoEditarGrupo}</button>
      </form>
    </div>
    <div className="col-md-6">
      <form onSubmit={self.addCertificationsToGroup}>
        <div className="form-group">
          <input type="hidden" name="name_to_group" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioCertificados.placeholder.NomeDoGrupo} value={self.state.certification_group_id} />
          <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioCertificados.Certificados}:</label>
          <Select
            className="form-field-name"
            name="certification_ids_to_agroup"
            value={self.state.certification_ids_to_agroup}
            searchable={true}
            multi={true}
            placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioCertificados.placeholder.SelecioneTipo}
            onChange={self.handleSelectChangeMulti.bind(self, 'certification_ids_to_agroup')}
            options={self.state.certifications_list}
          />
        </div>
        <div className="form-group">
          <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-plus"></i> {this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioCertificados.botaoIncluirCertificado}</button>
        </div>
      </form>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.tabelaCertificado.Certificado}
            </th>
            <th>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.tabelaCertificado.Acoes}</th>
          </tr>
        </thead>
        <tbody id="grupo-certificados">
          {Object.keys(self.state.certifications).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.certifications[k].certification_id}
                </td>
                <td>
                  {self.state.certifications[k].certification_name}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.certifications[k].certification_group_to_certification_id} onClick={self.deleteCertificationToGroup}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default CertificationGroupsCard;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationGroupsCard.js